import { AuthMode as AuthModeEnum } from '../../types/authMode';

export const BI_SISU_EVENT = 'BI_SISU_EVENT';

export type AuthMode = AuthModeEnum.DEVIANTART;
